export const actionTypes = {
  GET_COMBOS: "GET_COMBOS",
  SET_COMBOS: "SET_COMBOS",
  GET_COMBO_FILTERED_RESULTS: "GET_COMBO_FILTERED_RESULTS",
  SET_COMBO_FILTERED_RESULTS: "SET_COMBO_FILTERED_RESULTS",
  GET_COMBOS_BY_ID: "GET_COMBOS_BY_ID",
  SET_COMBOS_BY_ID: "SET_COMBOS_BY_ID",
  ADD_COMBOS: "ADD_COMBOS",
  GET_COMBO_PRODUCTS: "GET_COMBO_PRODUCTS",
  SET_COMBO_PRODUCTS: "SET_COMBO_PRODUCTS",
  GET_COMBO_EZDS: "GET_COMBO_EZDS",
  SET_COMBO_EZDS: "SET_COMBO_EZDS",
  DELETE_COMBO_PRODUCT: "DELETE_COMBO_PRODUCT",
  SET_DELETE_COMBO_PRODUCT: "SET_DELETE_COMBO_PRODUCT",
  EDIT_COMBO_FORM_CHANGE: "EDIT_COMBO_FORM_CHANGE",
  UPDATE_COMBO: "UPDATE_COMBO",
  SET_UPDATED_COMBO: "SET_UPDATED_COMBO",
  ADD_COMBOS_SUCCESSFUL: "ADD_COMBOS_SUCCESSFUL",
};

export const actions = {
  getComboProducts: (payload) => ({
    type: actionTypes.GET_COMBO_PRODUCTS,
    payload: payload,
  }),

  setComboProducts: (data) => ({
    type: actionTypes.SET_COMBO_PRODUCTS,
    payload: data,
  }),

  getComboEzds: (payload) => ({
    type: actionTypes.GET_COMBO_EZDS,
    payload: payload,
  }),

  setComboEzds: (data) => ({
    type: actionTypes.SET_COMBO_EZDS,
    payload: data,
  }),

  setCombosEditForm: (payload) => ({
    type: actionTypes.EDIT_COMBO_FORM_CHANGE,
    payload: payload,
  }),

  removeProduct: (payload) => ({
    type: actionTypes.DELETE_COMBO_PRODUCT,
    payload: payload,
  }),

  setRemoveProduct: (payload) => ({
    type: actionTypes.SET_DELETE_COMBO_PRODUCT,
    payload: payload,
  }),

  getCombos: (payload) => ({
    type: actionTypes.GET_COMBOS,
    payload: payload,
  }),

  setCombos: (payload) => ({
    type: actionTypes.SET_COMBOS,
    payload: payload,
  }),

  updateCombo: (payload, params) => ({
    type: actionTypes.UPDATE_COMBO,
    payload: payload,
    params: params,
  }),

  setUpdatedCombo: (payload) => ({
    type: actionTypes.SET_UPDATED_COMBO,
    payload: payload,
  }),

  getComboFilteredResults: (payload) => ({
    type: actionTypes.GET_COMBO_FILTERED_RESULTS,
    payload: payload,
  }),

  setComboFilteredResults: (payload) => ({
    type: actionTypes.SET_COMBO_FILTERED_RESULTS,
    payload: payload,
  }),

  getComboById: (payload) => ({
    type: actionTypes.GET_COMBOS_BY_ID,
    payload: payload,
  }),

  setComboById: (payload) => ({
    type: actionTypes.SET_COMBOS_BY_ID,
    payload: payload,
  }),

  addCombos: (payload) => ({
    type: actionTypes.ADD_COMBOS,
    payload: payload,
  }),

  addCombosSuccesful: (payload) => ({
    type: actionTypes.ADD_COMBOS_SUCCESSFUL,
    payload: payload,
  }),
};
